import React from 'react';
import messages from '../../text/messages';
import { FormattedMessage } from 'react-intl';
import image from '../../assets/images/guitar.png';
import './card.css';

const Image = () => (
    <div className="no-data-card__image">
        <img src={image} alt="" />
    </div>
);

const Body = ({ children, title = messages.emptyMessage, message }) => (
    <div className="no-data-card__body">
        <div className="no-data-card__title">
            <FormattedMessage {...title} />
        </div>
        <div className="no-data-card__message">
            <FormattedMessage {...message} />
        </div>
        {children}
    </div>
);

const NoDataCard = ({ children, pageTitleMessage }) => {
    const pageTitle = <FormattedMessage {...pageTitleMessage} />;
    return (
        <div className="no-data-card">
            <div className="tabs-title">
                <h4>{pageTitle}</h4>
            </div>
            <div className="no-data-card__container">{children}</div>
        </div>
    );
};

NoDataCard.Image = Image;
NoDataCard.Body = Body;

export default NoDataCard;



// WEBPACK FOOTER //
// ./src/components/noDataCard/index.jsx